import React from 'react';
import BaseView, {CustomFilterFrame} from '../../components/CRUDView';
import {FarmersEndpoints, FBOEndpoints, MiscEndpoints, UsersEndpoints} from '../../common/ProxyEndpoints';
import Avatar from '../../components/ProfileAvatar';
import EntityImageDisplay from "../../components/EntityImageDisplay/EntityImageDisplay";
import {Button, Row} from 'reactstrap';
import Utils, {exportFilteredCSV} from "../../common/Utils";
import DialogCollapseSection from "../../components/DialogCollapseSection/DialogCollapseSection";
import Icon from 'react-icons-kit';
import {ic_email} from 'react-icons-kit/md/ic_email';
import {ListItemView, PaginatedView} from "../../components/PaginatedView/PaginatedView";
import HistoryLink from "../../common/HistoryLink";
import SmartDialog from "../../components/SmartDialog/SmartDialog";
import FormRenderer from "../../common/FormRenderer/FormRenderer";
import MDProgress from 'react-md-progress-bar';
import HTML from '../../common/HtmlHelpers';
import {Permissions} from "../../common/Constants";
import Col from "reactstrap/es/Col";
import _ from "lodash";
import {getDistricts, getLocationRecord, getWards, listProvinces} from "../../data/locations";
import FarmersCommon from "../Farmers/FarmersCommon";

const SearchProps = [
    "name",
    "location",
    "user.phone"
];

const CacheDependency = [
    'dashboard',
    'farmers'
];

const Styles = {

    inputForm :{
        marginLeft: '5px',
        marginRight: '5px'
    }

};

/**
 * Handle management of FBO
 */
class FBO extends BaseView{

    constructor(props){
        super(props,'fbo_admin');
    }

    getFBOTotalFarmers(fboId){

        const rel = this.state.fboFarmerRel;
        if(rel) {

            let fbo = rel.find(x => x.fbo_id == fboId);
            if (fbo) {
                return fbo.totalFarmers;
            }
        }

        return 0;
    }

    getEditInputs(){

        const me = this;
        return [
            { name : 'username' , title: 'Username' , hint : 'Enter account username here...' , type: 'text' , icon : 'fa fa-user' , required: true , setValue: (input,item) =>  input.value = item.user.name , style: Styles.inputForm },
            { name : 'phone' , title: 'Phone Number' , hint : 'Enter phone number here...' , type: 'phone' , icon : 'fa fa-phone' , required: true  , setValue: (input,item) => input.value = item.user.phone , style: Styles.inputForm},
            { name : 'name' , title: 'Organization Name' , hint : 'Enter organization name here...' , type: 'text' , icon : 'fa fa-users' , required: true , style: Styles.inputForm},
            { name : 'location' , title: 'Location' , hint : 'Enter FBO location...' , type: 'location' , icon: 'fa fa-map-marker' , coord: {
                    lat: 'location_lat',
                    lng: 'location_long'
                }, style: Styles.inputForm, required: true },
            {

                render: (content,k) => {
                    return <DialogCollapseSection key={k} title="Optional" initiallyOpen={false}>
                        {content}
                    </DialogCollapseSection>
                },
                group: [
                    { name : 'email' , title: 'Email' , hint : 'Enter email here...' , type: 'email' , icon : <Icon icon={ic_email}/> , required: false , setValue: (input,item) => input.value = item.user.email , style: Styles.inputForm },

                ]
            },
        ];

    }

    getCreateInputs(){

        const me = this;
        return [
            {
                render: (k) => {
                    return <h5 key={k}>Account Info</h5>
                }
            },
            { name : 'username' , title: 'Username' , hint : 'Enter account username here...' , type: 'text' , icon : 'fa fa-user' , required: true , setValue: (input,item) =>  input.value = item.user.name , style: Styles.inputForm },
            { name : 'password' , title: 'Password' , hint: 'Enter account password. Default [username]@trotrotractor' , icon: 'fa fa-lock' , type: 'password' , style: Styles.inputForm },
            { name : 'phone' , title: 'Phone Number' , hint : 'Enter phone number here...' , type: 'phone' , icon : 'fa fa-phone' , required: true  , setValue: (input,item) => input.value = item.user.phone , style: Styles.inputForm},
            { name : 'name' , title: 'Organization Name' , hint : 'Enter organization name here...' , type: 'text' , icon : 'fa fa-users' , required: true , style: Styles.inputForm},
            { name : 'location' , title: 'Location' , hint : 'Enter FBO location...' , type: 'location' , icon: 'fa fa-map-marker' , coord: {
                    lat: 'location_lat',
                    lng: 'location_long'
                }, style: Styles.inputForm, required: true },
            {

                render: (content,k) => {
                    return <DialogCollapseSection key={k} title="Optional" initiallyOpen={false}>
                        {content}
                    </DialogCollapseSection>
                },
                group: [
                    { name : 'email' , title: 'Email' , hint : 'Enter email here...' , type: 'email' , icon : <Icon icon={ic_email}/> , required: false , setValue: (input,item) => input.value = item.user.email , style: Styles.inputForm },
                ]
            },

        ];

    }

    getCustomFilterState(filters) {

        return {
            name: filters.name || '',
            location: filters.location  || '',
            email: filters['user.email'] || '',
            phone: filters['user.phone'] || ''
        };

    }

    componentWillMount(){

        //
        const me = this;

        this.setViewOptions({

            //  The message to show when there are no items in the view
            noRowsMessage: "No FBO (Farmer Based Organization) available yet",

            //  The class icon for the card header
            pageIcon: 'icon-people',

            //  The title for the content frame
            pageTitle: 'FBO (Farmer Based Organization)',

            //  The total number of items per page
            maxItemsPerPage: 10,

            //  Defines the features of the view
            features: [ 'toolbox' , 'search' ],

            multiSelection: {

                //  enable multi-selection
                enable : false,
            },

            //  defines (CRUD) actions enabled on the items
            actions:{

                //  create action options
                create:{
                    text: 'Add FBO',
                    successCreateMsg: 'Created FBO successfully!',
                    failCreateMsg : 'Failed creating FBO!',
                    enabled: false,
                    editTitleMsg: 'Edit FBO',
                    createTitleMsg: 'Add FBO',
                    permissions:  [ Permissions.FBO.Create ]
                },

                //  delete action options
                delete: {

                    enabled : false,

                    //  Disallows the deleting of many items ??
                    disallowMany: false,

                    successDeleteMsg: 'Deleted FBO successfully!',
                    failDeleteMsg: 'Failed deleting FBO',
                    text: 'Delete',
                    confirmTitle: 'Confirm Delete FBO',
                    confirmMessage: 'Are you sure you want to delete FBO?',

                    //  The message to show when deleting many items
                    confirmManyMessage: "Delete selected FBO's?",
                    permissions:  [ Permissions.FBO.Remove ]
                },

                //  delete action options
                edit: {
                    enabled : true,
                    successEditMsg: 'FBO updated successfully!',
                    failEditMsg: 'Failed editing FBO',
                    text: 'Edit FBO',
                    permissions:  [ Permissions.FBO.Update ]
                }

            },

            hooks:{


                preQueryHook: () => {

                    return me.execReq(MiscEndpoints.getFBOFarmerRelations(false)).then(response =>{

                        return {
                            fboFarmerRel: response.getPayload()
                        };

                    });

                },

                postProcessorHook: (action,response) => {
                    Utils.eraseSession(CacheDependency);
                },

                renderCellActions: (item) => {

                    let actions = [

                        {
                            label: "Add Farmer",
                            icon: "fa fa-plus",
                            onClick: () => {

                                const _provinceList = listProvinces();
                                const _districtList = [];
                                const _selectDistrict =  "";
                                const _selectProvince = "";
                                const _wardList = [];

                                me.setStateSafe({
                                    _locationMode: 'custom',
                                    _selectProvince,
                                    _selectDistrict,
                                    _provinceList,
                                    _districtList,
                                    _wardList,
                                    contextItem: item
                                }, () => {
                                    me._createFarmerDialog.show();
                                });

                            }
                        },
                        {
                            label: "Show Farmers",
                            icon: "fa fa-eye",
                            onClick: () => {
                                return Utils.navigateLink(`/farmers?fbo_id=${encodeURIComponent(item.id.toString())}&_fbo_select_name=${encodeURIComponent(item.name)}`);
                            }
                        }

                    ];

                    if(me.proxy.isSuperUser()){

                        actions.push({
                            label: "Make Default",
                            icon: "fa fa-bolt",
                            onClick: async () => {

                                try{

                                    const res = await me.execReq(FBOEndpoints.setDefault(item.id));
                                    if(res.ok){
                                        HTML.toastSuccess('Default FBO changed successfully');
                                    }

                                }
                                catch (e) {
                                    HTML.toastError(Utils.getResponseError(e));
                                }

                            }
                        });


                    }


                    return actions;
                }

            },

            model:{
                include: [ 'user' , 'media' ]
            },

            filters: [
                {
                    key: 'name',
                    query: "name",
                    operator: '[]',
                    apply: true
                },
                {
                    key: 'location',
                    query: "location",
                    operator: '[]',
                    apply: true
                },
                {
                    key: 'user.phone',
                    query: 'phone',
                    operator: '[]',
                    apply: true
                },
                {
                    key: 'user.email',
                    query: "email",
                    operator: '[]',
                    apply: true
                }
            ],

            queryActions: {
                endpoint: FBOEndpoints.getUrl()
            },

            renderCustomFilters: ({ applyFilters , toggle , values , setValue , setValues , resetValues }) => {

                return <CustomFilterFrame toggle={toggle}>

                    <Row className="mb-1">
                        <Col md={3}>

                            <b>Name</b>
                            <input name="name"
                                   value={values['name']}
                                   onChange={evt => {
                                       setValue('name',evt.target.value);
                                   }}
                                   type="text"
                                   className="form-control form-input-select"
                                   placeholder="Search name"/>

                        </Col>

                        <Col md={3}>

                            <b>Phone</b>
                            <input name="phone"
                                   value={values['phone']}
                                   onChange={evt => {
                                       setValue('phone',evt.target.value);
                                   }}
                                   type="text"
                                   className="form-control form-input-select"
                                   placeholder="Search phone number"/>

                        </Col>

                        <Col md={3}>

                            <b>Email</b>
                            <input name="email"
                                   value={values['email']}
                                   onChange={evt => {
                                       setValue('email',evt.target.value);
                                   }}
                                   type="text"
                                   className="form-control form-input-select"
                                   placeholder="Search email"/>

                        </Col>


                        <Col md={3}>

                            <b>Location</b>
                            <input name="location"
                                   value={values['location']}
                                   onChange={evt => {
                                       setValue('location',evt.target.value);
                                   }}
                                   type="text"
                                   className="form-control form-input-select"
                                   placeholder="Search location"/>

                        </Col>
                    </Row>

                    <hr/>

                    <div className="clearfix">

                        <div className="pull-left">
                            <Button onClick={() => resetValues() }><i className="fa fa-refresh"/> Reset Filters</Button>
                        </div>

                        <div className="pull-right">
                            <Button color="green" style={{ borderRadius: 4 }} onClick={() => {

                                let _targetFilter = { };
                                Object.keys(values).forEach(k => {

                                    let _v = values[k];

                                    switch (k) {
                                        case "phone":
                                        case "email":
                                            k = `user.${k}`;
                                            break;
                                    }

                                    if(!_.isNil(_v) && _v !== ""){
                                        _targetFilter[k] = _v;
                                    }
                                    else{
                                        _targetFilter[k] = undefined;
                                    }

                                });

                                applyFilters(_targetFilter);


                            }}><i className="fa fa-check"/> Apply</Button>
                        </div>
                    </div>

                </CustomFilterFrame>
            },

            search:{

                //
                placeholder: 'Search fbo...',

                //  the mode for searching
                //  immediate: responsive
                //  explicit: wait till user hits the search button
                mode: 'explicit',

                //  The minimum characters to begin search with
                minSearchChars: 2,

                //  The searchable properties
                properties: SearchProps
            },

            //  Defines actions for toolbox
            toolBox: [
                { text: 'Add FBO' , icon:'fa fa-plus' , invoke: () => me.beginShowCreate() , position: 'right' , permissions:  [ Permissions.FBO.Create ] },
                {  text : 'Refresh'  , icon : 'fa fa-refresh'  , invoke: () => me.refresh() , position: 'right' },
                {  text : null  , icon : 'fa fa-sort'  , invoke: (index) => { me.configureSort();  }, position: 'right' , group : 'filter'},
                {  text : ''  , icon : 'fa fa-gears' , invoke: (index) => {

                        switch (index){
                            case 0:
                                return exportFilteredCSV(FBOEndpoints.exportCSV(),{ component: me });
                            case 1:
                                return me.toggleCustomFilterVisibility();
                        }

                    }, position: 'right' , group : 'more' ,
                    items: () => ([
                        <span><i className="fa fa-file-text"></i> Export to CSV</span>,
                        <span><i className={me.isCustomFilterViewVisible() ? "fa fa-chevron-up" : "fa fa-chevron-down"}/> {me.isCustomFilterViewVisible() ? "Hide" : "Show"} Advanced Filters</span>
                    ]),
                    sticky: false,
                }
            ],

            //  Inputs used in registering FBO
            inputsCreate: this.getCreateInputs(),

            //  Inputs used in editing FBO
            inputsEdit: this.getEditInputs(),

            sort: {

                properties: [
                    {
                        label: "Date Added",
                        value: "date_created"
                    },
                    {
                        label: "Name",
                        value: "name"
                    },
                    {
                        label: "Phone",
                        value: "phone"
                    },
                    {
                        label: "Location",
                        value: "location"
                    }
                ]
            },

            // Describes the columns present in the table
            columns : [
                { key: '__img' , label: ' ' , cell: (item,k) => <Avatar src={Utils.getProfileImage(item.media)}  name={Utils.formatAvatarName(item.name)}  size={32} /> , mobile: true },
                { key: 'name', label: () => me.sortCol("Name","name"), mobile: true  },
                { key: 'location', label: () => me.sortCol("Location","location") },
                { key: 'phone', label: () => me.sortCol("Phone",'user.phone') , cell : (item,key) => item.user ? Utils.standardValue(item.user.phone) : "N/A" , mobile: true  },
                { key: 'farmers', label:'Total No. Farmers' , cell: (item,key) => me.getFBOTotalFarmers(item.id) }
            ],

            //  Describes details to show when clicked
            detailsDisplay: {

                //  enable or disable
                enabled: true,

                renderTitle: (item) => {
                    return 'FBO Info';
                },

                onShow: (fbo) => {

                    this.setState({
                        _showInfo : true,
                        _farmers: null,
                        isBusy: true
                    });

                    const options = FBOEndpoints.getFBOFarmers(fbo.id);
                    options.include = ['media'];

                    // fetch farmers for fbo
                    return this.execReq(options).then(response => {

                        //  set farmers
                        this.setState({
                            _farmers: response.getPayload()
                        });

                    }).catch(err => {

                        //  show and allow retry
                        this.setState({
                            _farmers: Utils.errorState(err)
                        });

                    }).then(() => {

                        this.setState({
                            isBusy: false
                        });

                    });

                },

                customRender: (item) => {

                    const me = this;
                    const farmers = this.state._farmers || [];

                    return <div>
                        <div className="text-center">
                            <h5>Profile Image</h5>
                            <EntityImageDisplay
                                entityName="fbo"
                                entityId={item.id}
                                crudView={me}
                                onRemove={(media) => {
                                    me.updateItemMedia(item,media);
                                }}
                                onCompleteUpload={(media) => {
                                    me.updateItemMedia(item,media);
                                    return false;
                                }}
                                media={item.media} />
                        </div>

                        <DialogCollapseSection  initiallyOpen={true} title="Info" showToggle={!me.state.isBusy}>

                            <div className="row">
                                <div className="col-md-6">
                                    <dl>
                                        <dt>Username</dt>
                                        <dd>{item.user.name}</dd>

                                        <dt>Name</dt>
                                        <dd>{item.name}</dd>

                                        <dt>Phone</dt>
                                        <dd>{item.user ? item.user.phone : "N/A"}</dd>

                                        <dt>Email</dt>
                                        <dd>{Utils.standardValue(item.user.email)}</dd>
                                    </dl>
                                </div>
                                <div className="col-md-6">
                                    <dl>
                                        <dt>Total No. Farmers</dt>
                                        <dd>{farmers.length}</dd>

                                        <dt>Location</dt>
                                        <dd>{Utils.standardValue(item.location)}</dd>

                                        <dt>Date Registered</dt>
                                        <dd>{Utils.formatDateStandard(item.date_created)}</dd>
                                    </dl>
                                </div>
                            </div>
                        </DialogCollapseSection>

                        <hr/>

                        <DialogCollapseSection title="Farmers">
                            {/*this.state.isBusy ? <p>Loading...</p> : <Table rows={farmers} columns={FarmersDisplayColumns} className="table table-hover" settings={{ noRowsMessage: 'No farmers available!'}} />*/}
                            {this.state.isBusy ? <p>Loading...</p> : <PaginatedView
                                data={farmers}
                                emptyMessage="No farmers available"
                                //rowStyle="list-view-item"
                                onItemClick={(item) => {   }}
                                renderItem={(item) => {

                                    return <ListItemView avatarName={item.name}
                                                         media={item.media}
                                                         title={<HistoryLink navigateIcon={null} url={`/farmers?filter_id=${item.id}&q=${item.name}`}> <h6>{item.name}</h6></HistoryLink>}
                                                         subheader={<span> <b>Phone</b>:  {item.phone}</span>}
                                                         style={{borderBottomColor: 'gray', borderBottomWidth: '1px' }} />;
                                }} />}
                        </DialogCollapseSection>
                    </div>
                }

            },

            //  Processors
            processors :{

                //  create new item
                createItem: (proxy , payload) => {

                    const fboPayload = {
                        username: payload.username,
                        password: payload.password || `${payload.username}@trotrotractor`,
                        email: payload.email,
                        phone: payload.phone,
                        fbo:{
                            name: payload.name,
                            location: payload.location,
                            location_lat: payload.location_lat,
                            location_long: payload.location_long
                        }
                    };

                    //  register FBO account
                    return proxy.processRequest(UsersEndpoints.registerFBOAccount( false , false , fboPayload ));
                },

                //  called to delete many items
                deleteMany: (proxy,items) => {
                    return proxy.processRequest(FBOEndpoints.deleteFBO(items.map((item) => item.id)));
                },

                //  on edit item
                onEditItem: (proxy,item, inputs ) => {

                    const user = item.user;
                    inputs.email = inputs.email || null;

                    function updateAccount() {

                        return proxy.processRequest(UsersEndpoints.updateUser(item.user.id,{
                            username: inputs.username,
                            email: inputs.email,
                            phone: inputs.phone,
                            last_updated: item.user.last_updated
                        }));

                    }

                    function updateFBO() {

                        return proxy.processRequest(FBOEndpoints.update(item.id , {
                            name: inputs.name,
                            location: inputs.location,
                            location_lat: inputs.location_lat,
                            location_long: inputs.location_long,
                            last_updated: item.last_updated
                        }));

                    }

                    let promise = [];
                    if( ( inputs.username != user.username ) || (inputs.email != user.email) || (inputs.phone != user.phone) ){
                        promise.push(updateAccount());
                    }

                    if((inputs.name != item.name) || (inputs.location != item.location) || (inputs.location_lat != item.location_lat) || (inputs.location_long != item.location_long)){
                        promise.push(updateFBO());
                    }


                    return Promise.all(promise).then(values => {
                        return values[0];
                    });

                },

                //  on delete item
                onDeleteItem: ( proxy,item) => {
                    return proxy.processRequest( FBOEndpoints.deleteFBO(item.id) );
                }

            }
        });
    }

    onAddFarmer(inputs){

        const formRenderer = this._createFarmerInputs;
        const contextFBO = this.state.contextItem;
        this.setStateSafe({
            isAddingFarmer : true
        });

        const { _locationMode } = this.state;

        if(_locationMode === 'select'){

            const loc = getLocationRecord(inputs);
            if(loc){
                inputs.farm_location = [inputs.province,inputs.district,inputs.ward].join(",");
                inputs.farm_location_lat = loc.lat;
                inputs.farm_location_long = loc.lng;
            }

        }
        else if(_locationMode === 'custom'){
            inputs.province = null;
            inputs.district = null;
            inputs.ward = null;
        }

        return this.execReq( FarmersEndpoints.create(contextFBO.id,inputs) ).then(response => {

            this.setStateSafe({
                isAddingFarmer: false,
                contextItem: null
            });

            //  toggle dialog
            this._createFarmerDialog.toggle();

            //  show message
            HTML.toastSuccess("Farmer added successfully!");

            //  update item from list
            return this.execReq(MiscEndpoints.getFBOFarmerRelations(false)).then(response => {

                this.setStateSafe({
                    fboFarmerRel: response.getPayload()
                });

            });

        }).catch(err => {

            this.setStateSafe({
                isAddingFarmer: false
            });

            formRenderer.updateException(err);
        });

    }

    renderAdditionalDialogs(){

        const state = this.state;
        const isAddingFarmer = state.isAddingFarmer;

        return <div>

            {/*Create Farmer Dialog*/}
            <SmartDialog ref={r => this._createFarmerDialog = r}
                         title={"Add Farmer"}
                         showCancelButton={false}>

                <FormRenderer ref={r => this._createFarmerInputs = r}
                              onSubmit={this.onAddFarmer.bind(this)}
                              inputs={FarmersCommon.getFarmerInputs(undefined,{
                                  locationMode: this.state._locationMode,
                                  onLocationModeChange: mode => {
                                      this.setStateSafe({ _locationMode: mode })
                                  },
                                  provinces: this.state._provinceList,
                                  districts: this.state._districtList,
                                  wards: this.state._wardList,
                                  onProvinceChanged: value => {

                                      const _districtList = value ? getDistricts(value) : [];
                                      const _selectDistrict = _districtList.length > 0 ? _districtList[0].value : "";
                                      const _wardList =  _selectDistrict ? getWards(value,_selectDistrict) : [];
                                      const _selectWard = _wardList.length > 0 ?  _wardList[0].value : "";

                                      this.setState({
                                          _selectProvince: value,
                                          _selectDistrict,
                                          _districtList,
                                          _wardList
                                      },() => {

                                          const renderer  = this._createFarmerInputs;
                                          renderer.setInputValueWithName('district', _selectDistrict );
                                          renderer.setInputValueWithName('ward', _selectWard);

                                      });

                                  },
                                  onDistrictChanged: value => {

                                      const _wardList = getWards(this.state._selectProvince,value);
                                      const _selectWard = _wardList[0].value;

                                      this.setState({
                                          _selectDistrict: value,
                                          _wardList
                                      }, () => {

                                          const renderer  = this._createFarmerInputs;
                                          renderer.setInputValueWithName('ward', _selectWard);

                                      });

                                  }
                              })}
                              busy={isAddingFarmer}>

                    <hr/>

                    {isAddingFarmer && <MDProgress show={true} overlay={true}/>}

                    <div style={{ width: '100%' }}>
                        <Button color={"green"} block><i className="fa fa-plus"/> Add Farmer</Button>
                    </div>

                </FormRenderer>

            </SmartDialog>

        </div>
    }

    render(){
        return <div>
            {this.renderAdditionalDialogs()}
            {super.render()}
        </div>;
    }
}

export default FBO;



// WEBPACK FOOTER //
// ./src/views/FBOs/FBOs.js